import { IpSet } from "../../schema/types/ipset/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export const IpSetLocationRetentionPolicyOptions = [
  { label: "Keep", value: "keep" },
  { label: "Free", value: "free" },
];

export interface IpSetTableItem extends IpSet {
  selfLink: string;
}

interface GetIpSetTableItemProps {
  link?: string;
  name?: string;
  item?: IpSet;
}
export function getIpSetTableItem({ link, name, item }: GetIpSetTableItemProps): IpSetTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "ipset",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      spec: {},
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "ipset",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    spec: {},
    lastModified: "",
    tags: {},
    version: 1,
  };
}
